import { Outlet, useLocation } from 'react-router-dom'

export default function PublicLayout() {
  const location = useLocation()

  const handleAdminLogin = () => {
    window.location.href = '/login'
  }

  return (
    <div className="min-h-screen bg-iswara-gradient flex flex-col">
      {/* TopBar - Simple Header */}
      <header className="fixed top-0 left-0 right-0 z-50 bg-gradient-to-b from-[#1B5E20] to-[#1B5E20]/95 backdrop-blur-sm">
        <div className="max-w-2xl mx-auto h-14 px-4 flex items-center justify-between">
          <h1 className="text-white font-rajdhani font-bold text-lg tracking-wide">
            KEGIATAN ISWARA JATIM
          </h1>
          <button
            onClick={handleAdminLogin}
            className="px-4 py-1.5 bg-white/20 hover:bg-white/30 text-white text-sm font-rajdhani font-semibold rounded-lg transition-colors"
          >
            Admin
          </button>
        </div>
      </header>

      {/* Main Content */}
      <main className="flex-1 pt-14 pb-6 px-4">
        <div className="max-w-2xl mx-auto">
          <Outlet />
        </div>
      </main>

      {/* Footer */}
      <footer className="py-4 px-4 text-center">
        <p className="text-xs text-gray-400">@2026 developed by ephiewae</p>
      </footer>
    </div>
  )
}
